export default __webpack_public_path__ + "img/Cinnamomum_chago.4ebb20ed.jpg";